import * as yup from 'yup';
import { UnitsEnum } from '../apiConstants';

export const CustomerSchema = yup.object().shape({
  id: yup.string().required('ID is required'),
  name: yup.string().required('Name is required'),
  unitDisplay: yup
    .mixed<UnitsEnum>()
    .oneOf(Object.values(UnitsEnum), 'Invalid unit display')
    .required('Unit display is required'),
  language: yup.string().default('en'),
  shortCode: yup
    .string()
    .matches(/^[a-zA-Z0-9]*$/, 'Short code must be alphanumeric')
    .max(5, 'Short code must be at most 5 characters')
    .required('Short code is required'),
  fromDate: yup.string().nullable(),
  thruDate: yup.string().nullable(),
});

export type Customer = yup.InferType<typeof CustomerSchema>;
